import React, { useEffect, useRef, createElement } from 'react';
import { motion } from 'framer-motion';
import LogoSection from '../components/LogoSection';
import StatsSectionHealthcare from '../components/StatsSectionHealthcare';
import TaleOfTwoOwnersSection from '../components/TaleOfTwoOwnersSection';
import TeamSection from '../components/TeamSection';
import TimelineSection from '../components/TimelineSection';
import FAQSection from '../components/FAQSection';
const BookingPage = () => {
  const calendarRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // Load Calendly script
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  const scrollToCalendar = () => {
    calendarRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <main className="flex-grow" data-id="element-385">
      <section className="relative w-full bg-black min-h-[100vh] py-12 overflow-hidden" data-id="element-386">
        {/* Animated Gradient Background */}
        <div className="absolute inset-0 w-full h-full z-0 overflow-hidden" data-id="element-387">
          <div className="absolute inset-0 bg-gradient-to-br from-[#0a0a0a] via-[#0f0f0a] to-[#000000] animate-gradient-shift" data-id="element-388">
            <div className="absolute inset-0 opacity-30" data-id="element-389">
              <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top_right,_#ffdf07_0%,_transparent_60%)] animate-float-light-1" data-id="element-390"></div>
              <div className="absolute bottom-0 right-0 w-full h-full bg-[radial-gradient(ellipse_at_bottom_left,_#D4AF37_0%,_transparent_60%)] animate-float-light-2" data-id="element-391"></div>
              <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20" data-id="element-392"></div>
            </div>
          </div>
          <div className="absolute inset-0 bg-black bg-opacity-40 z-10" data-id="element-393"></div>
        </div>
        {/* Content */}
        <div className="relative z-20 w-full mx-auto py-8 px-4 sm:px-6 md:px-8 flex flex-col justify-center min-h-[90vh]" data-id="element-394">
          <div className="max-w-5xl mx-auto text-center" data-id="element-395">
            {/* Logo */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7
          }} className="mb-6" data-id="element-396">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iEuzHiZoD7HHWbnpRvvh2M/516lion.png" alt="516 Partners Logo" className="mx-auto w-24 sm:w-28 md:w-32" data-id="element-397" />
            </motion.div>
            {/* Headline */}
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.2
          }} className="text-white text-2xl sm:text-3xl md:text-4xl lg:text-5xl mb-4 typekit-heading leading-tight px-2" data-id="element-398">
              Congratulations! You have qualified for the{' '}
              <span className="text-[#ffdf07]" data-id="element-399">
                8 Figure Clinic MRI Strategy Call
              </span>
            </motion.h1>
            {/* Subtext */}
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.3
          }} className="libre-caslon-text-regular text-base sm:text-lg text-white mb-2 leading-relaxed px-2" data-id="element-400">
              Please book your time below
            </motion.p>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.4
          }} className="libre-caslon-text-regular text-xs sm:text-sm text-gray-400 mb-8 px-2 opacity-60" data-id="element-401">
              Calendar may take a few moments to load
            </motion.p>
            {/* Calendly Widget */}
            <motion.div ref={calendarRef} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.5
          }} className="w-full" data-id="element-402">
              <div className="calendly-inline-widget" data-url="https://calendly.com/ivanacuna13/8figureclinicmristrategycall" style={{
              minWidth: '320px',
              height: '700px'
            }} data-id="element-403"></div>
            </motion.div>
          </div>
        </div>
      </section>
      <LogoSection scrollToCalendar={scrollToCalendar} data-id="element-404" />
      <StatsSectionHealthcare scrollToCalendar={scrollToCalendar} data-id="element-405" />
      <TaleOfTwoOwnersSection scrollToCalendar={scrollToCalendar} data-id="element-406" />
      <TeamSection scrollToCalendar={scrollToCalendar} data-id="element-407" />
      <TimelineSection scrollToCalendar={scrollToCalendar} data-id="element-408" />
      <FAQSection scrollToCalendar={scrollToCalendar} data-id="element-409" />
    </main>;
};
export default BookingPage;